export default {
domainInvalid: {
  siteUnavailableTitle: "Site Indisponível",
  siteUnavailableDesc: "Este site está indisponível no momento.",
  contactAdmin: "Entre em contato com o administrador.",
  serverErrorTitle: "Serviço Indisponível",
  serverErrorDesc: "Falha ao conectar ao servidor, tente novamente mais tarde.",
  serverErrorTip: "A reconexão será feita automaticamente assim que o servidor voltar.",
  notAuthorizedTitle: "Domínio Não Autorizado",
  notAuthorizedDesc: "O domínio atual não está autorizado a acessar este serviço.",
  checking: "Verificando...",
  retry: "Tentar novamente",
  reload: "Recarregar",
  reloading: "Recarregando...",
  checkingDomain: "Verificando domínio...",
  authorizedRedirecting: "Domínio autorizado, redirecionando...",
  stillNotAuthorized: "O domínio ainda não está autorizado",
  reconnecting: "Reconectando..."
}
};
